import React, { useRef, useEffect,useState } from "react";
import './Header.scss'
import { motion } from 'framer-motion'
import floatstone from "./../../assets/images/floatstone.png"
import { gsap } from "gsap";
import waveman from "../../assets/images/waveman.png"
import circle from "../../assets/images/circle.svg"
import bgvideo from "../../assets/images/background-1.mp4"
import waverock from "../../assets/images/waverock.png"
import word1 from "../../assets/images/word1.png"
import bgimg from "../../assets/images/background-1.png"
import bgwaveman from "../../assets/images/bg-waveman.png"
import Planet1 from '../../assets/images/planet-1.png';
import Planet3  from '../../assets/images/planet-3.png';
const Header = () => {
    const [offsetY,setOffsetY]=useState(0)
    const [offsetX,setOffsetX]=useState(0)
    const handleScroll =()=>(setOffsetY(window.pageYOffset),setOffsetX(window.pageYOffset))
    let stoneEeffect = useRef(null);

    useEffect(()=>{
        window.addEventListener('scroll',handleScroll);
        return()=> window.removeEventListener("scroll",handleScroll)
    },[])
    // const handleHover = e => {
    //     gsap.to(stoneEeffect, {
    //         css: {
    //             display: "block"
    //         }

    //     })
    // }
    // //旋轉特效
    // const handleHoverExit = e => {
    //     gsap.to(stoneEeffect, {
    //         css: { display: "none" }
    //     })
    // }
    return (
        <div className="header">
            <div className="header-bg-container">
                <div className="header-wrapper">
                    <img className="floatstone" 
                        src={floatstone} alt="floatstone" />
                        {/* <img className="floatstone" onMouseEnter={e => handleHover(e)}
                        onMouseOut={e => handleHoverExit(e)}
                        src={floatstone} alt="floatstone" /> */}
                    {/* <div ref={el => (stoneEeffect = el)} className="stone-hover-effect">
                        <p>學名：漂浮石頭<br />（Float Stone）</p><br />
                        <span>一般發現於波波星外面</span><br />
                        <span>波波人常常看到會不爽</span><br />
                        <span>就用8Hz光波打爆他們</span><br />
                        <span>就像台灣三寶橫衝直撞</span><br />
                        <span>是不是 怪可愛的</span>
                    </div> */}
                    <div className="header-container">
                    <img className="bgimg" width="100%"  src={bgimg}  alt="img"  style={{transform:`rotate(-${offsetY*0.1}deg)`}}/>
                    <video className="bgVideo" src={bgvideo} type="video/mp4"  autoPlay muted loop style={{transform:`rotate(-${offsetY*0.1}deg)`}}/>
                   <img className="waverock" width="100%" src={waverock} alt="img"  />
                   <img className="word1" width="100%" src={word1} alt="img"  style={{transform:`translateX(-${offsetY*1}px)`}} />
                   <img className="bg-waveman" width="60%" src={bgwaveman} alt="img" style={{transform:`translateY(${offsetY*1}px)`}} />
                   <img className="plant1" width="10%" src={Planet1} alt="img"  style={{transform:`translateY(-${offsetY*0.6}px) `}}/>
                   <img className="plant2" width="20%" src={Planet3} alt="img"  style={{transform:`translateY(-${offsetY*1}px)translateX(${offsetX*0.2}px) `}}/>
                        <div className="header-main-container">
                            <div className="header-container-info">
                                {/* <h2>宇宙波波
                                    <br />來自外星系
                                    <br />8Hz生命體
                                </h2> */}

                                {/* <div class="button-container-2">
                                    <span class="mas">逛逛商場
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#686868" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M6 2L3 6v14c0 1.1.9 2 2 2h14a2 2 0 0 0 2-2V6l-3-4H6zM3.8 6h16.4M16 10a4 4 0 1 1-8 0" /></svg>
                                    </span>
                                    <button type="button" name="Hove">逛逛商場
                                        <svg width="16" height="12" viewBox="0 0 12 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M8.62381 0L8.05636 0.50423L10.4638 2.64347H0V3.3566H10.4637L8.05636 5.49577L8.62381 6L12 3L8.62381 0Z" fill="currentColor">
                                            </path></svg>
                                    </button>
                                </div> */}
                            </div>
                            <div className="header-container-picture">

                                {/* <motion.div
                                    whileInView={{ opacity: [0, 1] }}
                                    transition={{ duration: 0.8, delayChildren: 0.5 }}
                                    className="header-img"
                                >
                                    <img className='Waveman' src={waveman} alt="Waveman" />

                                    <motion.img
                                        whileInView={{ scale: [0, 0.8] }}
                                        transition={{ duration: 1, ease: "easeInOut" }}
                                        src={circle}
                                        alt="bg_circle"
                                        className="overlay_circle"
                                    />
                                </motion.div> */}





                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Header;

